import Vue from 'vue'
import { getImageConfig } from '../../assets/js/util'
import Util from '../../assets/js/util'
import {loadImage} from '../../assets/js/loadImageByPromise'
import CONST from '../../assets/js/const'
// import categoryMap from '../../assets/json/categoryMap.json'
// import ITEMS from '../../assets/json/items.json'
import SampleScene from "../../assets/js/SampleScene"
import { getSlatAndPartsListByType, getUpdateSuffix } from '../../assets/js/state_util'

const multiList = {
    "LD-7001": 10,
    "LD-7002": 10,
    "LD-7003": 10,
    "LD-7004": 10,
    "LD-7007": 3,
    "LD-7008": 3,
    "LD-7009": 3,
    "LD-7010": 3,
    "LD-7011": 3,
    "LD-7012": 3,
    "LD-7013": 3,
    "LD-7016": 3,
    "LD-7017": 3,
    "LD-7471": 3,
    "LD-7472": 3,
    "LD-7473": 3
  };
const setMultiTexToItemData = (item_data) => {
    const { name, width, height } = item_data
    const count = multiList[name]
    for (let i = 2; i < count + 1; i++) {
        Object.assign(item_data, {
            ...item_data,
            [`name${i}`]: `${name}_${i}`,
            [`width${i}`]: width,
            [`height${i}`]: height
        })
    }
    return item_data
}
const can_use_local_storage = Util.checkLocalStorageAvailable();

export default {
    namespaced: true,
    state: () => ({
        current_id: 0,
        image_list:[],
        editing_id: null,
        temp_item: null, //作成中仮アイテム 新規作成時などに使用
        is_operating: false,
        is_continuing_loading: false,
        selected_scene: 'living/living_5-1', //シーン初期値
        slat_list: [],
        slat_category: [],
        parts_list: [],
        is_rect_selected: false,
    }),
    mutations: {
        addImage(state, info) {
            state.image_list = [
                ...state.image_list,
                {id: state.current_id, order:state.current_id, ...info}
            ];
            state.slat_list = []
            state.current_id++;
        },
        removeItem(state, id) {
            const index = state.image_list.findIndex(d => d.id === id);
            state.image_list.splice(index, 1);
        },
        resetImageList(state) {
            state.image_list = [];
        },
        setSelectedScene(state, scene_name) {
            state.selected_scene = scene_name;
        },
        updateItem(state, payload) {
            const index = state.image_list.findIndex(d => d.id === payload.id);
            if ( index === -1 ) return;
            Vue.set(state.image_list, index, Object.assign(state.image_list[index], payload))
        },
        resetCurrentItem(state) {
            const index = state.image_list.findIndex(d => d.id === state.editing_id);
            Vue.set(state.image_list, index, {id: state.editing_id, order:state.editing_id})
        },
        createNewItem(state) {
            state.image_list = [
                ...state.image_list,
                {id: state.current_id, order:state.current_id, progress: 1, slat_select_ctg: {}, feature: ''}
            ];
            state.editing_id = state.current_id;
            state.current_id++;
        },

        createTempItem(state) { state.temp_item = {}; },
        deleteTempItem(state) { state.temp_item = null; },
        updateTempItem(state, payload) { state.temp_item = Object.assign(state.temp_item, payload) ;},

        setEditId(state, id) { state.editing_id = id },
        setIsOperating(state, bool) { state.is_operating = bool },
        swapItemOrder(state, payload) {
            const {id_a, id_b} = payload;
            const index_a = state.image_list.findIndex(d => d.id === id_a);
            const index_b = state.image_list.findIndex(d => d.id === id_b);
            const temp = state.image_list[index_a].order;
            Vue.set(state.image_list, index_a, Object.assign(state.image_list[index_a], {order: state.image_list[index_b].order}));
            Vue.set(state.image_list, index_b, Object.assign(state.image_list[index_b], {order: temp}));
        },
        updateSlatList(state, list) {
            state.slat_list = list
            const uniqCategory = list.reduce((uniq, {category}) => {
                return category ? uniq.add(category) : uniq
            }, new Set())
            state.slat_category = [...uniqCategory].map(name => {
                const rsrc = list.find(({category}) => category === name)
                return {
                    id: rsrc.ctgId,
                    imgId: rsrc.ctgImgId || rsrc.ctgId,
                    name,
                }
            })
            // const index = state.image_list.findIndex(d => d.id === state.editing_id)
            // if (index > -1 && state.slat_category.length === 1) {
            //     Vue.set(state.image_list, index, { ...state.image_list[index], slat_select_ctg: state.slat_category[0] })
            // }
        },
        setIsContinuingLoading(state, bool) {
            state.is_continuing_loading = bool;
        },
        setFeature(state, feature) {
            const index = state.image_list.findIndex(d => d.id === state.editing_id)
            if (index > -1) {
                Vue.set(state.image_list, index, { ...state.image_list[index], feature })
            }
        },
        setPartsList(state, parts_list) {
            state.parts_list = parts_list
        },
        setDisableIdList (state, idList) {
            const index = state.image_list.findIndex(d => d.id === state.editing_id)
            if (index > -1) {
                Vue.set(state.image_list, index, { ...state.image_list[index], disabled_ctg_id: idList })
            }
        },
        toggleTarget(state) {
            const index = state.image_list.findIndex(d => d.id === state.editing_id)
            if (index > -1) {
                const secondaryTarget = !state.image_list[index].secondaryTarget
                Vue.set(state.image_list, index, { ...state.image_list[index], secondaryTarget })
            }
        },
        setRectSelected(state, bool) {
            state.is_rect_selected = bool
        }
    },
    actions: {
        // 指定したidのアイテムのオーダーを一つ下げる
        updateItemOrderToLower({ commit, state }, id) {
            const item = state.image_list.find(d => d.id === id);
            if (!item) return;

            const {order: target_order} = item;
            const searched_obj = state.image_list.reduce((acc, item) => {
                return (target_order < item.order && item.order < acc.order) ? item : acc;
            }, {id: -1, order: 9999}); //9999は十分に大きい値とみなす
            if (searched_obj.id !== -1) commit('swapItemOrder', {id_a: id, id_b: searched_obj.id});
        },
        // 指定したidのアイテムのオーダーを一つ上げる
        updateItemOrderToUpper({ commit, state }, id) {
            const item = state.image_list.find(d => d.id === id);
            if (!item) return;

            const {order: target_order} = item;
            const searched_obj = state.image_list.reduce((acc, item) => {
                return (target_order > item.order && item.order > acc.order) ? item : acc;
            }, {id: -1, order: -1}); //-1は十分に小さい値とみなす
            if (searched_obj.id !== -1) commit('swapItemOrder', {id_a: id, id_b: searched_obj.id});
        },
        // 初期化
        async init({state, commit, dispatch }) {
            commit('updateSlatList', []);
            commit('setIsLoading', true, {root: true});

            //サンプルシーン
            if(state.selected_scene) {
                let [, sceneKey] = state.selected_scene.split('/')
                sceneKey = sceneKey in SampleScene ? sceneKey : 'default'
                // const clipping_image_update_process = (async () => {
                //     const img = await loadImage(`assets/images/${SampleScene[sceneKey].clipping_image}`);
                //     await dispatch('paint/setClippingImage', img, {root: true});
                // })();

                //各窓の枠線
                const initial_item_create_process = (async () => {
                    for(const rect_data of SampleScene[sceneKey].rect_data) {
                        commit('createNewItem');

                        const item_data = {
                            progress: 0,
                            slat_select_ctg: {},
                            disabled_ctg_id: [[]],
                            feature: '',
                            parts: '',
                            curtain_type: null,
                            item_data: {height: 0, name: "", width: 0},
                            item_type: CONST.ITEM_TYPE_CURTAIN,
                            points: rect_data.rect_position,
                            rect_width: rect_data.rect_width,
                            rect_height: rect_data.rect_height,
                        };
                        await dispatch('updateItemInfo', item_data);
                    }
                })();

                await Promise.all([initial_item_create_process]);

            //ユーザーのアップロード画像
            } else {
                //新規枠線
                commit('createNewItem');
                const coordinates = {
                    top_left:     {x: 332,  y: 93},
                    top_right:    {x: 732, y: 93},
                    bottom_left:  {x: 332, y: 573},
                    bottom_right: {x: 732, y: 573},
                };
                const item_data = {
                    progress: 0,
                    slat_select_ctg: {},
                    disabled_ctg_id: [[]],
                    feature: '',
                    parts: '',
                    curtain_type: null,
                    item_data: {height: 0, name: "", width: 0},
                    item_type: CONST.ITEM_TYPE_CURTAIN,
                    points: coordinates,
                    rect_width: 2500,
                    rect_height: 3000,
                };
                await dispatch('updateItemInfo', item_data);
            }

            commit('setIsLoading', false, {root: true});
        },
        // カーテン画像の生成
        // アイテムの情報を更新する 貼りこみ画像の生成も同時に行う
        async updateItemInfo({ commit, state, dispatch, getters }, update_info) {
            const id = update_info.id !== undefined ? update_info.id : state.editing_id; //payloadにidが含まれていなければ編集中アイテムをアップデート

            const index = state.image_list.findIndex(d => d.id === id);
            if ( index === -1 ) return;

            commit('setIsLoading', true, {root: true}); //loadingモーダルon

            if (!update_info.init && !update_info.recommend && update_info.item_data) {
                // 特定条件下で入力された item_data を操作
                try {
                    // prop 名をリネームする場合
                    const current = state.image_list[index]
                    if (getters.secondary_target) {
                        const props = ['name', 'width', 'height', 'ctgId'];
                        const inputProps = Object.keys(update_info.item_data);
                        // 入力された item_data の prop が name, width, height の時に限定
                        if (inputProps.length === props.length
                            && inputProps.every(k => props.includes(k))) {
                            const { productType, feature } = current;
                            const sfx = getUpdateSuffix(productType, feature.type);
                            const renamed = props.reduce((obj, k) => {
                                obj[`${k}${sfx}`] = update_info.item_data[k];
                                delete update_info.item_data[k];
                                return obj
                            }, {});
                            Object.assign(
                                update_info.item_data,
                                { ...current.item_data, ...renamed }
                            );
                        }
                    }
                    // 複数枚のテクスチャのある品番だった場合
                    if (multiList[update_info.item_data.name]) {
                        setMultiTexToItemData(update_info.item_data)
                    } else {
                    // 通常テクスチャへの切り替え時にマルチテクスチャの情報を消去
                        if (current.item_data && current.item_data.name !== '') {
                            const keys = ['name', 'width', 'height'].flatMap(k => {
                                return [2, 3].map(n => `${k}${n}`)
                            })
                            const toDelete = Object.keys(current.item_data)
                                .filter(k => keys.includes(k));
                            if (toDelete.length > 0) {
                                toDelete.forEach(k => delete current.item_data[k])
                                Vue.set(state.image_list, index, current)
                                console.log(state.image_list[index])
                            }
                        }
                    }
                } catch (err) {
                    console.log(`${err}`)
                }
            } else if (update_info.init) {
                if (multiList[update_info.item_data.name]) {
                    setMultiTexToItemData(update_info.item_data)
                }
            }

            // metaデータ用の配列
            if (update_info.item_data) {
                Object.assign(
                    update_info.item_data,
                    { ...(update_info.init ? {} : state.image_list[index].item_data), ...update_info.item_data }
                );
                // metaデータを収集
                let meta = [];
                const {prefix, productType} = state.image_list[index];
                const getDisplayName = (name) => {
                    // 'PL'ではじまる productType 以外の時は基本的にdisplayを使用する
                    const useDisplayProp = !productType?.startsWith('PL');
                    return useDisplayProp
                        ? (state.slat_list.find(({id}) => id === name)?.display || name)
                        : name;
                }
                const { item_data } = update_info;
                if (prefix) {
                    const productMeta = await import('../../assets/json/productType.json')
                        .then(({default: m}) => m.find(({prefix: id}) => id === prefix));
                    const { name: productName, types } = productMeta;
                    const { name: slatName } = types.find(({type}) => type === productType);
                    let label;
                    if ('name_lace' in item_data) {
                        label = { name: 'ドレープ', name_lace: 'レース' }
                    } else if ('name_bottom' in item_data) {
                        label = { name: '上生地', name_bottom: '下生地' }
                    } else if ('name_back' in item_data) {
                        label = { name: '前生地', name_back: '奥生地' }
                    }
                    if (label) {
                        meta = Object.keys(label).map((key, idx) => {
                            const displayName = getDisplayName(item_data[key]);
                            const head = idx > 0 ? '' : `${productName} / ${slatName} / `;
                            return {
                                text: `${head}${displayName} (${label[key]})`,
                                prefix,
                                name: item_data[key]
                            }
                        })
                    } else {
                        const displayName = getDisplayName(item_data.name);
                        meta.push({
                            text: `${productName} / ${slatName} / ${displayName}`,
                            prefix,
                            name: item_data.name
                        })
                    }
                }
                Object.assign(update_info, { meta });
            }

            if (update_info.init) {
                update_info.secondaryTarget = false;
                delete getters.editing_item.laceChanged;
            }
            delete update_info.init
            delete update_info.recommend

            const curtain_data = Object.assign(state.image_list[index], update_info);

            curtain_data.rect_height = getters.editing_item.rect_height;

            //base64でカーテン画像を生成する（three.js、glfx）
            //張り込み画像と描画に必要な情報を取得 必要な情報が足りなければnullが返ってくる
            curtain_data.image_config = await getImageConfig(curtain_data);

            let min_order;
            if(curtain_data.item_type === 'curtain') {
                //重なりを一番上に
                min_order = Math.min(...state.image_list.map(ele => ele.order)) - 1;
            } else {
                //重なりを壁紙の中で一番上に
                const wall_list = state.image_list.filter(ele => ele.item_type === 'wall');
                if(wall_list.length === 0) {
                    min_order = 10000;
                } else {
                    min_order = Math.min(...wall_list.map(ele => ele.order)) - 1;
                }
            }
            curtain_data.order = min_order;

            commit('updateItem', curtain_data);
            dispatch('saveEditDataToLocalStorage');

            if(!state.is_continuing_loading) commit('setIsLoading', false, {root: true}); //loadingモーダルoff
        },
        async reverseSlatPairing ({ commit, getters, dispatch }) {
            const { editing_item } = getters;
            const { item_data, productType, feature, secondaryTarget, slat_select_ctg } = editing_item;
            commit('setDisableIdList', editing_item.disabled_ctg_id.reverse());

            const sfx = getUpdateSuffix(productType, feature.type);
            const keys = ['name', 'width', 'height', 'ctgId'];
            if (secondaryTarget) {
                keys.forEach(k => {
                    item_data[k] = item_data[`${k}${sfx}`];
                })
            } else {
                keys.forEach(k => {
                    item_data[`${k}${sfx}`] = item_data[k];
                })
            }
            const revSelectCtg = {};
            ['id', 'name'].forEach(k => {
                revSelectCtg[k] = slat_select_ctg[`${k}2`]
                revSelectCtg[`${k}2`] = slat_select_ctg[k]
            })

            await dispatch('updateItemInfo', {item_data, slat_select_ctg: revSelectCtg});
        },
        // アイテムデータの削除、リセット
        removeItemData({ commit, dispatch }, id) {
            commit('removeItem', id);
            dispatch('saveEditDataToLocalStorage');
        },
        resetItemList({ commit, dispatch }) {
            commit('resetImageList');
            commit('updateSlatList', []);
            commit('setPartsList', [])
            // dispatch('saveEditDataToLocalStorage');
            // ここのinitの呼び出しはおかしい、というかinitがおかしい
            dispatch('init');
        },
        // 編集アイテムを変更する 表示に必要な各種情報も設定しなおす
        async setEditingId({ commit, state, getters }, id) {
            commit('setEditId', id);

            await Vue.nextTick(); //getter更新待ち
            const {file_name, rect_width, rect_height, is_check_pattern, is_curtain, prefix, productType, feature} = getters.editing_item;

            if (file_name) commit('setCurrentImage', file_name, {root: true});
            if (rect_width) commit('setRectWidth', rect_width, {root: true});
            if (rect_height) commit('setRectHeight', rect_height, {root: true});
            if (typeof is_check_pattern === 'boolean') commit('setCheckPattern', is_check_pattern, {root: true});
            if (typeof is_curtain === 'boolean') commit('setIsCurtain', is_curtain, {root: true});
            if (prefix) {
                const [slatList, partsList] = await getSlatAndPartsListByType(prefix, productType)
                commit('setFeature', feature)
                commit('setPartsList', partsList)
                commit('updateSlatList', slatList)
            }
        },
        // 仮作成アイテムデータをアイテムリストに追加
        async commitTempItem({ state, commit, dispatch }) {
            if (!state.temp_item) return;
            commit('createNewItem');
            console.log(state.image_list.map(({id}) => id))
            await dispatch('updateItemInfo', state.temp_item);
            await commit('updateTempItem', state.image_list.find(({id}) => id === state.editing_id))
        },
        async initTempItem({ commit, dispatch, getters }) {
            commit('updateSlatList', [])
            let points = CONST.INITIAL_RECT_POSITION;

            const item_data = {
                curtain_type: null,
                item_data: null,
                progress: 0,
                slat_select_ctg: {},
                disabled_ctg_id: [[]],
                feature: '',
                parts: '',
                item_type: CONST.ITEM_TYPE_CURTAIN,
                points: points,
                rect_width: 2500,
                rect_height: 3000,
            };
 
            await dispatch('updateItemInfo', {...getters.editing_item, ...item_data});
        },
        // 編集データをjson形式でlocalStorageに保存
        saveEditDataToLocalStorage({ state }) {
            if ( !can_use_local_storage ) return;
            localStorage.setItem(CONST.LOCAL_STORAGE_KEY, JSON.stringify(state.image_list));
        },
        // localStorageに保存された編集データを復元する
        async restoreEditDataFromLocalStorage({ commit, dispatch }) {
            if ( !can_use_local_storage ) return;
            const edit_data_json = localStorage.getItem(CONST.LOCAL_STORAGE_KEY);
            const saved_img = localStorage.getItem(CONST.LOCAL_STORAGE_IMG_KEY);

            if (edit_data_json) {
                const edit_data = JSON.parse(edit_data_json);
                const await_list = edit_data.map(item_data => {
                    delete item_data.id;
                    delete item_data.order;
                    delete item_data.image_config;

                    commit('createNewItem');
                    // updateItemInfo自体にsetIsLoadingが使われているので
                    // ローディングモーダルを付けたままにするため個別で対応
                    return (async () => {
                        await dispatch('updateItemInfo', item_data);
                        commit('setIsLoading', true, {root: true});
                    })();
                });

                await Promise.all(await_list);
                commit('setIsLoading', false, {root: true});
            }
            if (saved_img) {
                try{
                    commit('setIsLoading', true, {root: true});
                    const img = await loadImage(saved_img);
                    commit('setBackgroundImage', img, {root: true});
                    commit('setIsLoading', false, {root: true});
                } catch (e) {
                    //失敗しても不都合はないのでモーダルのみ消す
                    commit('setIsLoading', false, {root: true});
                }
            }
        },
        setSlatCtgSelected({commit, getters}, ctgObj) {
            const current = getters.editing_item;
            const updated = !('id2' in ctgObj) && current.secondaryTarget
                ? Object.keys(ctgObj).reduce(
                    (acc, k) => { acc[`${k}2`] = ctgObj[k]; return acc }, {}
                    )
                : ctgObj;
            commit('updateItem', {...current, slat_select_ctg: {
                ...current.slat_select_ctg,
                ...updated
            }})
        },
        resetSlatCtgSelected({commit, getters}) {
            commit('updateItem', {...getters.editing_item, slat_select_ctg: {}})
        },
        setDisabledCtgId({commit, getters} , idList) {
            const { disabled_ctg_id, secondaryTarget } = getters.editing_item
            disabled_ctg_id.splice(secondaryTarget ? 1 : 0, 1, idList)
            commit('setDisableIdList', disabled_ctg_id)
        },
        justUpdateItemInfo({ commit, state }, payload) {
            const id = state.editing_id;
            const index = state.image_list.findIndex(d => d.id === id);
            if ( index === -1 ) return;
            const data = {...state.image_list[index], ...payload}
            commit('updateItem', data);
        },
        async updateItemProductType({ commit, dispatch }, {prefix, type, feature, ...options}) {
            const [slatList, partsList] = await getSlatAndPartsListByType(prefix, type)
            commit('setFeature', feature)
            dispatch('resetSlatCtgSelected')
            commit('setPartsList', partsList)
            commit('updateSlatList', slatList)
            dispatch('justUpdateItemInfo', {
                prefix,
                productType: type,
                feature,
                ...options
            })
        },
    },
    getters: {
        editing_id: state => {
            return state.editing_id
        },
        wall_in_imageList: state => {
            return state.image_list.filter(({item_type}) => item_type === 'wall')
        },
        editing_item: state => {
            const index = state.image_list.findIndex(d => d.id === state.editing_id);
            return state.image_list[index] || { progress: -1 };
        },
        editing_progress: (_, getters) => {
            return getters.editing_item.progress
        },
        editing_productType: (_, getters) => {
            return getters.editing_item.productType
        },
        feature: (_, getters) => {
            return getters.editing_item.feature
        },
        editing_parts: (_, getters) => {
            return getters.editing_item.parts
        },
        editing_prefix: (_, getters) => {
            return getters.editing_item.prefix
        },
        editing_meta: (_, getters) => {
            return getters.editing_item.meta
        },
        slat_category: state => {
            return state.slat_category
        },
        is_slat_selected: (_, getters) => {
            const key = getters.secondary_target ? 'id2' : 'id'
            return key in getters.editing_item.slat_select_ctg
        },
        slat_select_ctg: (_, getters) => {
            const keys = getters.secondary_target ? ['id2', 'name2'] : ['id', 'name']
            if (keys[0] in getters.editing_item.slat_select_ctg) {
                return keys.reduce((selected, k) => (
                    {
                        ...selected,
                        [k]: getters.editing_item.slat_select_ctg[k]
                    }
                ), {})
            } else {
                return {}
            }
            // return getters.secondary_target ? getters.editing_item.slat_select_ctg
        },
        slat_ctg_by_product: (state, getters) => {
            if (!['ZF', 'ZF-FE-PAIR', 'PL-PAIR', 'PL-DOUBLE', 'LD-PE-100', 'HS-PAIR'].includes(getters.editing_productType)) {
              return state.slat_category
            }
            return state.slat_category.filter(({id}) => !getters.disabled_ctg_id.includes(id))
        },
        parts_list: state => {
            return state.parts_list
        },
        all_meta: state => {
            return state.image_list.flatMap(({meta}) => {
                return meta ? meta : []
            });
        },
        disabled_ctg_id: (_, getters) => {
            const editing_item = getters.editing_item
            const ids = editing_item.disabled_ctg_id
            return Array.isArray(ids) ? ids[getters.secondary_target ? 1 : 0] : []
        },
        secondary_target: (_, getters) => getters.editing_item.secondaryTarget,
        sorted_image_list: state => [...state.image_list].sort((a,b) => a.order - b.order),
    },

}
